var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.31825 8.98045L6.88168 10.3713L8.27254 15.9347C8.44334 16.6179 9.37648 16.7103 9.67795 16.0739L16.428 1.82391C16.7296 1.18703 16.066 0.523359 15.4291 0.82504L1.17908 7.57504C0.542643 7.87651 0.635042 8.80965 1.31825 8.98045ZM7.68173 9.02524L3.71484 8.03351L14.173 3.07963L9.21916 13.5378L8.22744 9.57094C8.16026 9.30223 7.95045 9.09241 7.68173 9.02524Z",
    fill: "#00206E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2197 0.96967C15.5126 0.676777 15.9874 0.676777 16.2803 0.96967C16.5507 1.24003 16.5715 1.66546 16.3427 1.95967L16.2803 2.03033L8.03033 10.2803C7.73744 10.5732 7.26256 10.5732 6.96967 10.2803C6.69931 10.01 6.67851 9.58454 6.90728 9.29033L6.96967 9.21967L15.2197 0.96967Z",
    fill: "#00206E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.1205e5069d3e91e50b0be2e02f1ee35b.svg";
export { ForwardRef as ReactComponent };